import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Button } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'tely';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <Row className="full-height">
          <Col sm="2" lg="2" md="2"></Col>
          <Col sm="7" lg="7" md="7" className="login-tely-container">
            <Form onSubmit={(event) => onSubmit(event)}>
              <img src={logo} alt="logo" className="logo-tely rounded d-block" />
              <div className="tely-title">Login</div>
              <Row>
                <div className="tely-textfield tely-user">
                  <Input
                    className="tely-input"
                    bsClass=""
                    disabled={onLogin}
                    required={true}
                    tabIndex={1}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="user"
                    onChange={e => setUsername(e.target.value)}
                  />
                  <label>Usuário</label>
                  <div className="tely-left-icon">
                    <svg style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
                      <path fill="#7D7D7D" d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
                    </svg>
                  </div>
                  <div className="tely-right-icon">
                    <svg style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
                      <path fill="#b00020" d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                    </svg>
                  </div>
                </div>
                <div className="tely-textfield tely-password">
                  <Input
                    className="tely-input"
                    bsClass=""
                    required={true}
                    disabled={onLogin}
                    tabIndex={1}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    onChange={e => setPassword(e.target.value)}
                  />
                  <label>Senha</label>
                  <div className="tely-left-icon">
                    <svg style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
                      <path fill="#7D7D7D" d="M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z" />
                    </svg>
                  </div>
                  <div className="tely-right-icon">
                    <svg style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
                      <path fill="#b00020" d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                    </svg>
                  </div>
                </div>
              </Row>
              {!onLogin ? (
                <Row style={{ padding: 0 }}>
                  <Col sm="6" md="6" lg="6" style={{ textAlign: 'left' }}>
                    <Button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      type="submit"
                      id="submmit"
                      className="enter-tely"
                      disabled={onLogin || !props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </Button>
                  </Col>
                  <Col sm="6" md="6" lg="6">
                    <p style={{ fontSize: "16px", paddingTop: '38px', textAlign: 'end' }}>
                      <a href="https://minhately.tely.com.br/app_redefine_senha/">Esqueci minha senha</a>
                    </p>
                  </Col>
                </Row>
              ) : (
                <Progress animated color="danger" value={100} />
              )}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </Form>
          </Col>
          <Col sm="3" lg="3" md="3"></Col>
        </Row>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
